import React from "react";
import { motion } from "framer-motion";
// import "./../styles/global.css";
// import Footer from "../components/Footer";
import "./../styles/service.css";
import top_left from "../images/top_left.png"
import bottom_left from "../images/bottom_left.png"
import pro_service from "../images/pro_service.png"
import batch from "../images/batch.png";
import Footer from "./../components/Footer"
 const services =() =>{
    return (
      <>
      <motion.div
        className="hero-section"
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
<h1 className="service-h1">WE PROVIDE THESE SERVICES.....</h1>
        <div className="Service-main-page">
          
          <div className="service-left">
          <div className="service-centere-div">
         <h2>OUR ERP MODULES..</h2>
          </div>
          </div>
          <div className="service-right"></div>

        </div>
        {/* ==================== erp modile ke niche ka part manufacturing bala part ========================================== */}
        <div className="service-manufacturing">
  <h1 className="servive-manufacturing-heading">MANUFACTURING</h1>
  <p className="service-manufacturing-text">
    <b>Inventory Dashboard :-  All your materials, one place, real-time updates </b><br></br>
    <b>Procurement Hub :- Smarter purchasing, better planning.</b><br></br>
    <b>Warehouse Manager :- Seamless control over store and stock movement.</b><br></br>
    <b>Operations Board :- Track and assign work orders efficiently.</b><br></br>
    <b>Component Breakdown :- Visual representation of product structure (BOM).</b><br></br>
    <b>Manufacturing Plan :- Plan, manage, and monitor production orders.</b><br></br>
    <b>Packed & Ready :- Finalized items prepared for dispatch.</b><br></br>
    <b>Shipping Desk :- Streamlined outbound logistics and delivery tracking.</b>
  </p>

  <div className="service-manufacturing-mid">
    {/* This section can be styled or kept as is */}
  </div>

  <div className="service-manufacturing-left">
    <img src={top_left} alt="Manufacturing Image 1" /><br></br>
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    <img src={bottom_left} alt="Manufacturing Image 2" />
  </div>
</div>
{/* ============================ projects ========================================== */}
<div className="service-projects">
  <div className="service-projects-left"></div>
  <div className="service-projects-right">
   <div className="service-projects-right-text">
   <h1 className="service-projects-heading">PROJECTS</h1>
   <div className="service-projects-text">
    <b>Project Creation :- Kickstart projects with templates, timelines, and mapped resources.   </b><br></br>
    <b>Activity :- Plan, schedule, and monitor each task involved in the project lifecycle for efficient execution.</b><br></br>
    <b>Est Eft :- Forecast resource hours and manpower required for accurate project cost and time planning.</b><br></br>
    <b>Material :- Streamline material requests, availability checks, and reservations for seamless operations. </b><br></br>
    <b>Purchase :- Initiate smart procurement strategies linked directly to project needs and timelines.</b><br></br>
    <b>Consumption :- Track real-time usage of materials against planned quantities to reduce waste and costs. </b><br></br>
    <b>Project Close :- Finalize deliverables, validate milestones, and generate project completion reports. </b><br></br>
    
  </div>
   <img src={pro_service}></img>
    </div> 
  </div>

</div>
{/* ===================== Batch =================== */}
<div className="batch"> 
  <div className="batch-left">
<h1 className="batch-heading">  Batch</h1>
<div className="batch-text">
      <b>BATCH :- Items produced in one cycle; helps in tracking production and expiry.</b><br></br>
      <b>MATERIALS :- Raw materials used in making products; main input in production.</b><br></br>
      <b>PURCHASE :- Process of ordering and buying materials from suppliers or vendors. </b><br></br>
      <b>STORES :- Place where raw or finished goods are stored and managed.</b><br></br>
      <b>FG STOCK :- Finished goods ready to be sold or dispatched to customers.</b><br></br>
      <b>BATCH STOCK :- Current available stock, grouped by production batch number.</b><br></br>
      <b>DESPATCH :- Final step where products are shipped or delivered to clients.</b><br></br>

    </div>
  </div>
  <div className="batch-right">
    <img className="batch-img" src={batch}></img>
   
  </div>

</div>

      </motion.div>
      <br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br>
      <br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br>
      <br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br>
  
      <Footer/>
      </>
    );
  };
  
  export default services;